import { TITLE_TYPE } from './dynamic-data-table.model';
import { DashboardContainerComponent } from '../layout/dashboard-container/dashboard-container.component';
import { AxisType, BarChartModel, CHART_TYPE, CommonChartModel, PieChartModel } from './chart.model';
import { TabConfig, SECTION_TYPE, dynamicComponentSchema, DynamicFormArray, FormFieldConfig, Props, DisplayTranformation } from './form.model';
import { AreaRegionDropdown, EventBillingEventDropdown, EventBillingYearDropdown, FieldNames, TotalAmountText, TotalCountText } from './form-fields.model';
import { DYNAMIC_IDENTIFIER } from './common.model';
import { ChartComponent } from '../layout/chart/chart.component';
import { DynamicCardsComponent, DynamicCardSchemaItem } from '../components/dynamic-cards/dynamic-cards.component';
import { environment } from '../../../environments/environment';
import { ApiEnvNames, FETCH_METHODS, SearchConfig } from './api.model';
import { EventBillingReportComponent } from '../components/event-billing-report/event-billing-report.component';
import { FormContainerComponent } from '../layout/form/form-container/form-container.component';

export const EventBillingTitle = "Event Billing";

export const DealerCode ="Dealer Code";
export const DealerName ="Dealer Name";
export const DealerArea ="Dealer Area";
export const DealerDistrict ="Dealer District";


export const EventBillingBaseUrl = () => {
    return environment['eventBilling'];
};
const FormFieldArray: FormFieldConfig[] = structuredClone([]);


export const EventDashboardReportProps: Props = {
    istitleCenter: true,
}

export const SectionNames = {
    AreaBillingYear: 'billingTrendPerYear',
    BillingTrendsDealer: 'billingTrendsDealer',
    AttendenceCountDealersYear: 'attendenceCountDealersYear',
    AttendenceCountDealers: 'attendenceCountDealers',
    EventBillingSummary: 'eventBillingSummary',
    EventBillingReport: 'eventBillingReport',
    GetEventsAndYears: 'getEventsAndYears',
    GetDistinctOrganisations: 'getDistinctOrganisations',
} as const;
export type FetchMethod = typeof SectionNames[keyof typeof SectionNames];

export const EventBillingDashboardCommonPayload = {
    "year": "",
    "yearType": ""
}

export const FetchConfig: Record<FetchMethod, SearchConfig> = {
    [SectionNames['AreaBillingYear']]: {
        path: 'eventBillingTrendPerYear',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']

    },
    [SectionNames['BillingTrendsDealer']]: {
        path: 'dealerTrendPerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']
    },
    [SectionNames['AttendenceCountDealersYear']]: {
        path: 'dealerAttendancePerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']
    },

    [SectionNames['AttendenceCountDealers']]: {
        path: 'overallAttendanceCount',
        method: FETCH_METHODS['Get'],
        body:{
            [FieldNames['Area']]:''
        },
        urlPath: ApiEnvNames['EventBilling']
    },
    [SectionNames['EventBillingSummary']]: {
        path: 'eventBillingSummary',
        method: FETCH_METHODS['Get'],
        body: {
            event: '',
            year: '',
        },
        urlPath: ApiEnvNames['EventBilling']
    },
    [SectionNames['EventBillingReport']]: {
        path: 'overallCourseAttendance',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']
    },
    [SectionNames['GetEventsAndYears']]: {
        path: 'getEventsAndYears',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']
    },
    [SectionNames['GetDistinctOrganisations']]: {
        path: 'getDistinctOrganisations',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['EventBilling']
    },

}

export const EventBillingTabIds = {
    Dashboard: 'dashboard',
    Report: 'report',
    ManageExceptionReport: 'manageExceptionReport'
}

export const EventAreaBillingYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Amount</span>: <b>$ {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'totalAmount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            yAxis: {
                title: 'Cost ($)'
            },
            drillDownField: "dealerDetails",
            label: "dealer",
            value: "amount",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Amount</span>: <b>$ {point.dataset.amount}</b><br/>`
            },
            titleSchema: {
                title: `Billing trends of ${DYNAMIC_IDENTIFIER['drilldownField']} for ${DYNAMIC_IDENTIFIER['globalyear']}`,
                subTitle: ``,
                type: TITLE_TYPE['Dynamic']
            },
        }
    },
    titleSchema: {
        label: '',
        title: `Area billing trend for ${DYNAMIC_IDENTIFIER['globalyear']}`,
        type: TITLE_TYPE['Dynamic']
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealer',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + `$` + "{point.y}"
    }
};

export const EventBillingTrendsDealerChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        pointFormat: `
        <br/>
        <span>Dealer Name</span>: <b><span>{point.dataset.dealerName}</span></b><br/>
        <span>Area</span><span>: <b>{point.dataset.areaName}</b></span><br/>
        <span>District</span>: <b><span>{point.dataset.district}</span></b><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>`
    },
    dataSchema: {
        label: 'dealer',
        value: 'amount',
    },
    titleSchema: {
            label: '',
            subLabel: '',
            title: 'Billing Trend across Dealers',
            subTitle: `For  ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
    },
    xAxis: {
        labels: {
            style: {
                fontSize: '8px',
            },
        },
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    }
};

export const EventAttendenceCountDealersYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px"><b>{point.name} Count</b></span><br>',
        pointFormat: `<b><span>{point.y}</span></b><br/>`
    },
    dataSchema: {
        label: 'status',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            yAxis:{
                title: 'Count'
            },
            drillDownField: 'dealerDetails',
            type: CHART_TYPE['ColumnChart'],
            label: 'dealer',
            value: 'count',
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Count</span>: <b>{point.dataset.count}</b><br/>`
            },
            titleSchema: {
                    label: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by Dealer for ${DYNAMIC_IDENTIFIER['globalyear']}`,
                    type: TITLE_TYPE['Dynamic'],
                    subTitle: ""
            }
        }
    },
    titleSchema: {
            label: '',
            title: `Attendance count across Dealer for ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealer',
        }
    },
    yAxis: {
        title: {
            text: 'COUNT',
        }
    },
}
export const EventAttendenceCountDealersChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px"><b>{point.dataset.dealer}</b></span><br>',
        pointFormat: `
        <span>Dealer Name</span>: <b><span>{point.dataset.dealerName}</span></b><br/>
        <span>Dealer Area</span>: <b><span>{point.dataset.areaName}</span></b><br/>
        <span>Dealer State</span>: <b><span>{point.dataset.accountState}</span></b><br/>
        <span>Dealer District</span>: <b><span>{point.dataset.district}</span></b><br/>
        <span>Dealer City</span>: <b><span>{point.dataset.accountCity}</span></b><br/>
        <span>Dealer Location</span>: <b><span>{point.dataset.accountAddress1}</span></b><br/>
        <span>{point.nameKey}</span>: <b><span>{point.y}</span></b><br/>
        `
    },
    legend: {
        enabled: true,
    },
    dataSchema: {
        label: 'dealer',
        value: ['noShowCount', 'completedCount'],
        tooltipLabelInfo: {
            'noShowCount': "No Show Count",
            'completedCount': "Completed Count"
        }
    },
    titleSchema: {
        [FieldNames['Area']]: {
            label: '',
            title: `Attendance count of each Dealer for ${DYNAMIC_IDENTIFIER['globalyear']}`,
            subTitle: '',
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        title: {
            text: 'Count',
        }
    },
    yAxis: {
        title: {
            text: 'No of People',
        }
    },
    plotOptions: {},
    series: [{
        name: 'Completed',
        type: CHART_TYPE['BarChart'],
        data: [],
        key: 'completedCount'
    },
    {
        name: 'No Show',
        type: CHART_TYPE['BarChart'],
        data: [],
        key: 'noShowCount'
    }]
};

export const EventDashboardReportFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    title: 'Event Summary'
};

export const EventBillingSummaryCardsSchema: DynamicCardSchemaItem[] = [
    {
        label: 'Total Amount ($)',
        subLabel: 'Total Billed Amount',
        fieldKey: 'total_amount',
        valueType: 'amount'
    },
    {
        label: 'Total',
        subLabel: 'Total Registered',
        fieldKey: 'total_records'
    },
    {
        label: 'Attended',
        subLabel: 'Associates who attended the event',
        fieldKey: 'total_completed_records'
    },
    {
        label: 'No Show',
        subLabel: 'Associates who did not attend the event',
        fieldKey: 'total_no_show_records'
    }

];

export const EventBillingFilterInfoText = 'Please select Year and Event to view the details';
export const EventBillingGridSchema: Array<dynamicComponentSchema> = [
    {
        component: FormContainerComponent,
        type: SECTION_TYPE['GlobalFilter'],
        inputs: {
            dynamicFormArray: {
                formName: 'eventBillingGlobalFilter',
                FieldsArray: structuredClone([
                   { ...EventBillingYearDropdown, required:true ,showSelect:false},
                    { ...EventBillingEventDropdown ,required:true, displayTranformation: DisplayTranformation.none },
                ]),
                searchConfig: {
                    method: "POST",
                    path: "",
                    body: {
                        "year": "",
                        "yearType": ""
                    }
                }
            },
        }, 
    },
    {
        component: DynamicCardsComponent,
        type: SECTION_TYPE['Dashboard'],
        inputs: {
            elementId: SectionNames['EventBillingSummary'],
            schema: EventBillingSummaryCardsSchema,
            apiConfig: FetchConfig[SectionNames['EventBillingSummary']],
            columns: 4,
            rows: 1,
            format: 'borderCard',
            defaultLoader: true,
            onLoadFetch: false
        }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: EventAreaBillingYearChart,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AreaBillingYear'],
            apiConfig: FetchConfig[SectionNames['AreaBillingYear']],
            exportConfig: {
                fileName: 'Area_Billing_Trend_Dealers',
                exportMessage: "Area Billing Trend Dealers Data",
                isCamelCase:['dealerName','area'],
                schema: {
                    dealer: DealerCode,
                    dealerName: DealerName,
                    area: DealerArea,
                    district: DealerDistrict,
                    amount: "Amount($)"
                }
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: 'totalAmount'
            }]),
            globalFilterFields: [FieldNames['Year'], FieldNames['Event']],
            requiredGlobalPayloadFields: ['eventId'],
            defaultLoader: true,
            onLoadFetch:false

        }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: EventBillingTrendsDealerChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['BarChart'],
            elementId: SectionNames['BillingTrendsDealer'],
            apiConfig: FetchConfig[SectionNames['BillingTrendsDealer']],
            exportConfig: {
                fileName: 'Billing_Trend_Across_Dealers',
                exportMessage: "Billing Trend Across Dealers Data",
                isCamelCase:['dealerName','areaName'],
                schema: {
                    dealer: DealerCode,
                    dealerName: DealerName,
                    areaName: DealerArea,
                    district: DealerDistrict,
                    amount: "Amount($)",
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([])
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: "amount"
            }]),
            globalFilterFields: [FieldNames['Year'], FieldNames['Event']],
            requiredGlobalPayloadFields: ['eventId'],
            defaultLoader: true
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: EventAttendenceCountDealersYearChart,
            onLoadFetch: false,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AttendenceCountDealersYear'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountDealersYear']],
            exportConfig: {
                fileName: 'Event_Attendance_Count_Dealers',                
                exportMessage: "Attendance Count Dealers Data",
                isCamelCase:['dealerName','area'],
                schema: {
                    dealer:"DEALER CODE",
                    dealerName:"DEALER NAME",
                    area: "AREA",
                    district:"DISTRICT",
                    status:"STATUS",
                    count: "COUNT",
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([]),
            },
            infoFields: structuredClone([{
                ...TotalCountText, calculateBy: 'totalCount'
            }]),
            globalFilterFields: [FieldNames['Year'], FieldNames['Event']],
            requiredGlobalPayloadFields: ['eventId'],
            defaultLoader: true
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: EventAttendenceCountDealersChart,
            onLoadFetch: false,
            chartType: CHART_TYPE['BarChart'],
            elementId: SectionNames['AttendenceCountDealers'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountDealers']],
            exportConfig: {
                fileName: 'Dealer_Attendance',
                exportMessage: "Dealer Attendance Data",
                isCamelCase:['dealerName','areaName','accountAddress1','accountCity'],
                schema: {
                    dealer: "DEALER CODE",
                    dealerName: "DEALER NAME",
                    areaName: "DEALER AREA",
                    accountState: "DEALER STATE",
                    district: "DEALER DISTRICT",
                    accountCity: "DEALER CITY",
                    accountAddress1: "DEALER ADDRESS",
                    completedCount: "COMPLETED COUNT",
                    noShowCount: "NO SHOW COUNT",
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([
                    AreaRegionDropdown
                ]),
            },
            infoFields: structuredClone([{
                ...TotalCountText, calculateBy: ['noShowCount', 'completedCount']
            }]),
            globalFilterFields: [FieldNames['Year'], FieldNames['Event']],
            requiredGlobalPayloadFields: ['eventId'],
            defaultLoader: true
        }
    }
];

export const EventBillingTabSchema: Array<TabConfig> = [{
    label: 'Charts',
    tabId: EventBillingTabIds['Dashboard'],
    type: SECTION_TYPE.Dashboard,
    component: DashboardContainerComponent,
    inputs: {
        gridSchema: EventBillingGridSchema,
        props: { title: EventBillingFilterInfoText }
    }
}, {
    label: 'Reports',
    tabId: EventBillingTabIds['Report'],
    type: SECTION_TYPE.FilterWithTable,
    component: EventBillingReportComponent,
    inputs: {}
}];
